import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-svg-tas',
    templateUrl: './svg-tas.component.html',
    styleUrls: ['./svg-tas.component.css'],
    standalone: false
})
export class SvgTasComponent implements OnInit {
  @Input() darkcolor;
  @Input() lightcolor;

  constructor() { }

  ngOnInit() {
  }

}
